import { List } from "@mantine/core";

export const UpdateList = ({ children }: { children: React.ReactNode }): JSX.Element => {
  return (
    <List ml="xl" pl={"md"}>
      {children}
    </List>
  );
};
